// Component-specific styles
import './promotionList.scss'

// Custom Organism Components
import {CustomDataTable, FileUploadWithModal, UploadHistoryTableModal, UploadMediaModal} from '@/components/organisms'

// Custom Hooks
import {usePromotionColumns} from '@/hooks/usePromotionColumns'
import {usePromotionList} from '@/hooks/usePromotionList'

// Constants
import {Constants, DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {MAIN_COLUMNS, SUB_COLUMNS} from './PromotionListConstants'

/**
 * PromotionsList component displays a sortable, filterable, and paginated list of promotions.
 */
export const PromotionsList = () => {
  const {
    promotionListData,
    promotionListColConfigData,
    setSearchArry,
    isLoading,
    resetAllBtnClicked,
    formData,
    setFormData,
    downloadPromoTemplate,
    downloadPromotionFile,
    getPromotionFileUploadErrors,
    downloadUploadError,
    uploadHistoryData,
    toggleMultipleImagesModal,
    isMultipleImagesModal,
    handleCopyClick,
    handleResetAll,
    handleSorting,
    handlePageIndexChange,
    isSelectAll,
    setSelectAll,
    isModal,
    toggleModal,
    openUploadHistory,
    setOpenUploadHistory,
    setSelectedRows,
    tableActions,
  } = usePromotionList()

  const transformedColumns = usePromotionColumns(promotionListColConfigData, handleCopyClick)

  // Prepare columns for UploadHistoryTableModal
  const columns = MAIN_COLUMNS(downloadPromotionFile, downloadUploadError)

  return (
    <div className="product-admin-promotions-list">
      <CustomDataTable
        columns={transformedColumns}
        records={promotionListData?.data || []}
        setSearchArry={setSearchArry}
        handleSorting={handleSorting}
        setPageIndex={handlePageIndexChange}
        pageSize={DEFAULT_TABLE_PAGE_SIZE}
        totalRecords={promotionListData?.totalRecords}
        onResetAll={() => {
          handleResetAll()
          resetAllBtnClicked()
        }}
        onRowSelect={selectedRows => setSelectedRows(selectedRows)}
        tableHeader="Promotions List"
        isLoading={isLoading}
        actions={tableActions}
        id="id"
        showActions={true}
        isSelectAll={isSelectAll}
        setSelectAll={setSelectAll}
        defaultSortConfig={{key: 'activeStartDate', direction: 'desc'}}
      />
      <FileUploadWithModal
        openUpload={isModal}
        setOpenUpload={toggleModal}
        setFormData={setFormData}
        formData={formData}
        title="Bulk Upload Promotions"
        showTertiaryButton={true}
        uploadFor={'product'}
        isCsvValidationRequired={false}
        isTemplateUpload={true}
        label={'Upload Bulk Promotion file'}
        toastMessage={'File has successfully been uploaded and the status can be checked in Upload History'}
        tertiaryButtonText={'Download Template'}
        onClickTertiaryButton={downloadPromoTemplate}
        showTertiaryDownloadButton={true}
        acceptedExtensions={Constants.Xlsx}
      />
      <UploadHistoryTableModal
        openUploadHistory={openUploadHistory}
        setOpenUploadHistory={setOpenUploadHistory}
        mainData={uploadHistoryData?.data || []}
        totalRecords={uploadHistoryData?.totalRecords}
        mainColumns={columns}
        subColumns={SUB_COLUMNS}
        fetchSubRows={getPromotionFileUploadErrors}
        isDark={true}
        setPageIndex={0}
        text={
          'Access original files under File Path column, or download error reports by clicking Failed to resolve issues.'
        }
      />

      <UploadMediaModal
        openUpload={isMultipleImagesModal}
        setOpenUpload={toggleMultipleImagesModal}
        title="Upload Media"
        showTertiaryButton={true}
        formData={formData}
        setFormData={setFormData}
        entityType="promotion"
      />
    </div>
  )
}
